import NSDesign from './generic/NSDesign';
window.NSDesign = NSDesign;
NSDesign.init();
